import React, { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Popover,
  Typography,
  Box,
} from '@mui/material'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { useNotificationsCalls } from '../../hooks'
import { PopupDialogComponent } from '../../dialogs'
import { useIntl } from 'react-intl'
import { NoticesPopupComponent } from '../notices-popup'

export const NoticesHistoryComponent = () => {
  const intl = useIntl()
  const { formatMessage } = intl

  const [anchorEl, setAnchorEl] = React.useState(null)
  const { getAvisosByUser, markAsRead } = useNotificationsCalls()
  const [notifications, setNotifications] = useState(null)
  const [nottificationsNotRead, setNottificationsNotRead] = useState(0)

  const [selectedAviso, setSelectedAviso] = useState({})
  const [openDialog, setOpenDialog] = useState(false)

  useEffect(() => {
    getAvisosByUser({ params: { full: true } }).then((response) => {
      setNotifications(response.data)
      setNottificationsNotRead(getNotReadNotifications(response.data))
    })
  }, [])

  useEffect(() => {
    setNottificationsNotRead(getNotReadNotifications(notifications))
  }, [notifications])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  function closeDialog() {
    setOpenDialog(false)
    setSelectedAviso({})
  }

  function readAviso() {
    markAsRead(selectedAviso.id).then(() => {
      const newAvisos = notifications.map((aviso) =>
        aviso.id === selectedAviso.id ? { ...aviso, ignore: true } : aviso
      )
      setNotifications(newAvisos)
      closeDialog()
    })
  }

  const showDetail = (notification) => () => {
    setAnchorEl(null)
    const aviso = {
      id: notification.id,
      title: notification.title,
      text: notification.body,
      links: notification.links,
      ignore: notification.ignore,
    }
    setSelectedAviso(aviso)
    setOpenDialog(true)
  }

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return new Date(date).toLocaleDateString('es-ES', options)
  }

  const getNotReadNotifications = (not) => {
    if (!not) return 0
    return not.filter((notification) => !notification.ignore).length
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        color="primary"
        aria-label="Notificaciones"
        size="large"
      >
        {nottificationsNotRead > 0 ? (
          <Badge badgeContent={nottificationsNotRead} color="secondary">
            <NotificationsIcon />
          </Badge>
        ) : notifications && notifications.length > 0 ? (
          <NotificationsIcon />
        ) : (
          <NotificationsNoneIcon />
        )}
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ width: '20rem', p: 1, maxHeight: '80vh', overflowY: 'auto' }}>
          {' '}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 2, pb: 0, mb: 2 }}>
            <Typography variant="h6" gutterBottom color="primary">
              <i>{formatMessage({ id: 'pages.notices.history.title' })}</i>
            </Typography>
          </Box>
          {notifications &&
            notifications.map((notification) => (
              <Card
                key={notification.id}
                variant="outlined"
                sx={{
                  mb: 2,
                  background: '#f3f3f3',
                  position: 'relative',
                }}
              >
                {!notification.ignore ? (
                  <Badge color="secondary" badgeContent=" " sx={{ width: '100%' }}>
                    <CardContent sx={{ pb: 0 }}>
                      <Typography variant="h6" component="div">
                        {notification.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        component="div"
                        dangerouslySetInnerHTML={{ __html: notification.body }}
                        sx={{
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      />
                    </CardContent>
                  </Badge>
                ) : (
                  <CardContent sx={{ pb: 0 }}>
                    <Typography variant="h6" component="div">
                      {notification.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      component="div"
                      dangerouslySetInnerHTML={{ __html: notification.body }}
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    />
                  </CardContent>
                )}
                <CardActions>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Button size="small" color="primary" onClick={showDetail(notification)}>
                      Ver detalles
                    </Button>
                    <Typography variant="caption" component="div">
                      {formatDate(notification.start_date)}
                    </Typography>
                  </Box>
                </CardActions>
              </Card>
            ))}
          {notifications && notifications.length === 0 && (
            <Typography variant="body1" component="div" sx={{ p: '0 20px 20px 20px' }}>
              <i>{formatMessage({ id: 'pages.notices.history.empty' })}</i>
            </Typography>
          )}
        </Box>
      </Popover>

      {selectedAviso.title && (
        <PopupDialogComponent
          open={openDialog}
          onClose={closeDialog}
          onRead={readAviso}
          {...selectedAviso}
        />
      )}
      <NoticesPopupComponent avisos={notifications} setAvisos={setNotifications} />
    </>
  )
}
